import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import {
  AgrPageToolbarModule,
  AgrSummaryCardModule,
  AgrSummaryCardHorizontalModule,
  AgrDaterangePickerModule,
  AgrNotificationEmptyModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { AgrTableModule } from '@next/core-lib/table';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { AttentionSummaryComponent } from './components/attention-summary/attention-summary.component';
import { DairyOverviewComponent } from './components/dairy-overview/dairy-overview.component';
import { IndividualProductionComponent } from './components/individual-production/individual-production.component';
import { MilkDeliveryComponent } from './components/milk-delivery/milk-delivery.component';
import { MilkDeliveryMonthSummaryComponent } from './components/milk-delivery-month-summary/milk-delivery-month-summary.component';
import { ProductionComponent } from './components/production/production.component';
import { ProductionSettingsComponent } from './components/production-settings/production-settings.component';
import { AttentionLimitsEffects } from './store/effects/attention-limits.effects';
import { MilkDeliveryEffects } from './store/effects/milk-delivery.effects';
import { ProductionEffects } from './store/effects/production.effects';
import { attentionLimitsReducer } from './store/reducers/attention-limits.reducers';
import { milkDeliveryReducer } from './store/reducers/milk-delivery.reducers';
import { productionReducer } from './store/reducers/production.reducers';

@NgModule({
  imports: [
    AgrDaterangePickerModule,
    MatTableModule,
    AgrDialogModule,
    AgrFormModule,
    AgrPageToolbarModule,
    AgrSummaryCardModule,
    AgrSummaryCardHorizontalModule,
    AgrNotificationEmptyModule,
    AgrTableModule,
    CommonModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatSortModule,
    MatSlideToggleModule,
    SharedModule,
    ProductionComponent,
    IndividualProductionComponent,
    ProductionSettingsComponent,
    AttentionSummaryComponent,
    MilkDeliveryComponent,
    MilkDeliveryMonthSummaryComponent,
    DairyOverviewComponent,
  ],
  providers: [
    provideState('milk-delivery', milkDeliveryReducer),
    provideState('production', productionReducer),
    provideState('attention-limits', attentionLimitsReducer),
    provideEffects([ProductionEffects, AttentionLimitsEffects, MilkDeliveryEffects]),
  ],
})
export class DairyresultsModule {}
